module.exports = __webpack_public_path__ + "img/gameTronos12.30c9aa1c.jpg";